/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used in labels.
 * @export
 */
export const COMPONENT_SERVICE_STRINGS = {
  aboutComponent: `About this component`,
  add: 'Add',
  addHeader: 'Add header',
  addToSet: `Add to set`,
  addVariable: 'Add variable',
  allComponents: `All components`,
  allComponentsInSet: `All components in this set`,
  allVersionsAvailable: `All versions available`,
  and: `and`,
  apiError: `There was a problem completing your request. Please try again later.`,
  backToAllComponents: `Back to all components`,
  cancel: `Cancel`,
  cannotReadEnvironmentVariables: 'You do not have permissions to view environment variables.',
  cannotWriteEnvironmentVariables: 'You do not have permissions to update environment variables.',
  componentDetails: `Component details`,
  componentPreview: `Component preview`,
  components: `Components`,
  componentService: `Component Service`,
  componentSetDetails: `Component set details`,
  componentSetExists: `This component set already exists, please try again with a different ID.`,
  componentSetHeadersDescription: 'Set custom headers for this component set',
  componentSets: `Component sets`,
  componentSpecificOverrides: 'Component specific overrides',
  createNewComponentSet: `Create a new component set`,
  createNewSet: `Create new set`,
  createSet: `Create set`,
  createSetDescription: `Enter the name, ID and description of the component set you would like to create`,
  createVariableOverride: `Create new environment variable override`,
  delete: 'Delete',
  deleteAllComponentVersions: 'Delete all component versions',
  deleteAllComponentVersionsDescription:
    'This will permanently delete all versions of this component. Are you sure you want to proceed?',
  deleteAllComponentVersionsError: 'There was a problem deleting this component. Please try again later.',
  deleteError: `There was a problem deleting this component from the set. Please try again later.`,
  description: `Description`,
  duplicateEnvVarName: `This variable name is already in use`,
  editableVersioningTitle: `Which versions can editors add to page?`,
  editableVersions: `Editable versions: `,
  editableVersionsAdd: `Add to edit list`,
  editableVersionsLatest: `Latest available`,
  editableVersionsNone: `None`,
  editableVersionsSelect: `Select specific editable versions`,
  editableVersionsSpecify: `Specific versions`,
  environmentVariables: `Environment variables`,
  environmentVariablesDescription:
    'These fields are required and will be used set wide. You can also create environment variable overrides for each specific component if needed.',
  excludedVersions: `Excluded versions: `,
  excludedVersionsAdd: `Add to exclude list`,
  excludedVersionsSelect: `Select specific versions to exclude`,
  excludeSpecificVersionsTitle: `Exclude specific versions`,
  headerName: 'Header name',
  headers: 'Headers',
  id: `ID`,
  idDescription: `Enter a meaningful unique identifier for your set. This will be displayed in URLs used by developers for debugging. Use alphanumeric characters and hyphens only.`,
  includedInSets: `Included in these sets`,
  incorrectPermissionsEnvVar: `You do not have access to view or edit environment variables`,
  instances: `Instances`,
  instancesInUse: `Instances in use across all sets`,
  invalidEnvVarName: `This variable name is invalid, variable names can only contain [A-Za-z0-9._-]`,
  invalidID: `Invalid ID. Accepted characters are upper-case and lower-case letters, digits 0 through 9, and the hyphen character '-'. Cannot start with the word 'squiz'.`,
  legacy: `Legacy`,
  listTitle: `You are adding a component to:`,
  loadMore: `Load more`,
  manage: `Manage`,
  manageComponentVersions: `Manage component versions`,
  matrixApiIdentifiers: 'Matrix API Identifiers',
  matrixIdentifierActionCreate: 'Create',
  matrixIdentifierActionDelete: 'Delete Matrix API Identifier',
  matrixIdentifierActionEdit: 'Update',
  matrixIdentifierDeleteWarning: 'The identifier will be deleted immediately',
  matrixIdentifierErrorAlreadyExists: 'This identifier already exists',
  matrixIdentifierHeadingCreate: 'Add Matrix API Identifier',
  matrixIdentifierHeadingDelete: 'Delete this Matrix API Identifier',
  matrixIdentifierHeadingEdit: 'Edit Matrix API Identifier',
  matrixIdentifierPropApiKey: 'API Key',
  matrixIdentifierPropApiUrl: 'API URL',
  matrixIdentifierPropName: 'Identifier Name',
  more: `more`,
  name: `Name`,
  noAvailableSets: `No available sets`,
  noComponentSets: `There are no component sets in this library`,
  noComponentsInSet: `There are no components in this set`,
  noComponentSpecificOverrides: 'You have no component specific overrides',
  noEnvironmentVariables: 'You have no environment variables',
  noneFound: `None found`,
  noPreview: `No preview defined for the selected component version.`,
  noRequiredVariables: `component has no required environment variables`,
  noVariablesSets: `No variables set`,
  remove: 'Remove',
  removeComponentFromSet: `Remove component from set`,
  removeComponentFromSetDescription: `Are you sure you want to remove this component from this set?`,
  removeFromAllSets: 'You must remove this component from all sets before you can permanently delete it.',
  renderableVersions: `Renderable versions: `,
  renderableVersionsAll: `All versions`,
  renderableVersionsNone: `None`,
  renderableVersionsSpecify: `Specify a range`,
  renderableVersionsTitle: `Which versions can be rendered?`,
  requestHeaders: `Request headers`,
  requiredField: `This field is required`,
  requiredVariables: `component has the following required environment variables:`,
  save: 'Save',
  searchComponent: `Search component`,
  select: `Select`,
  selectComponent: `Select the component you would like to add to this set`,
  selectVersion: `Please select a version of this component you would like to be added to this set`,
  set: `Set`,
  setConfigurations: `Set configurations`,
  setEnvironmentVariables: 'Set environment variables',
  setGlobalVariables: `Set as global environment variables`,
  sets: `Sets`,
  specifyVersions: `Specify version`,
  squizEditWarning: `Squiz sets and related components are managed by Squiz and cannot be edited.`,
  useLatestVersion: `Use latest version available`,
  useTheButtonBelow: `Use the button below to`,
  variableName: 'Variable Name',
  versioning: `Versioning`,
  versionRules: `Version rules`,
  versionRulesValid: `Invalid renderable component version semver value`,
  versionUsedIn: `Version used in `,
  viewInSet: `View in set`,
};
